<template>
  <div v-if="masterLoad && !error" :class="['externa']">
    <div class="interna"></div>
  </div>
  <div v-else-if="error && !masterLoad" class="div-erro">
    <div class="container box-msg">
      <i>
        <font-awesome-icon :icon="icon" />
      </i>
      <p :key="mensagem" v-html="mensagem"></p>
      <!-- <a href="http://www.econeteditora.com.br" >Clique aqui</a> para voltar ao site da Econet -->
    </div>
  </div>
  <preloader v-else :class="{ 'troca-cor': trocaCores }" />
</template>

<script>
// import Preloader from "@/components/Preloader/Preloader.vue";
import Preloader from "@/views/Preloader/Preloader.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Validate",
  components: {
    preloader: Preloader
  },

  provide() {
    return {
      toggleTrocaCores: this.toggleTrocaCores
    };
  },

  data() {
    return {
      masterLoad: true,
      error: false,
      mensagem: "",
      icon: "",
      type: 401,
      trocaCores: false
    };
  },

  created() {
    this.validaLogin();
  },

  computed: {
    ...mapGetters("login", {
      paramId: "getParamId"
    })
  },

  methods: {
    ...mapActions("auth", ["setUsuarioPro"]),
    ...mapActions("login", [
      "setParamId",
      "login",
      "obterAssinatura",
      "verificarAlertas",
      "preLogin"
    ]),
    ...mapActions("empresa", ["fetchListaEmpresas"]),
    toggleTrocaCores() {
      this.trocaCores = !this.trocaCores;
    },

    validaLogin: function() {
      if (this.$route.params.id === undefined) {
        if (!this.paramId) {
          this.error = true;
          this.showError(403);
          return;
        }
        //console.log('38 for store id: ', this.paramId)
        this.masterLoad = false;
      } else {
        if (this.$route.params.id == "MzgwNDg=") {
          this.setParamId(this.$route.params.id);
          this.setUsuarioPro(true);
          //console.log('42 set param id to store: ', this.$route.params.id)

          this.login(this.$route.params.id)
            .then(response => {
              if (!response.data.status) {
                this.showError(401);
                return;
              }

              this.obterAssinatura()
                .then(response => {
                  this.fetchListaEmpresas();
                  //console.log(response)
                })
                .catch(error => {
                  console.log(error);
                })
                .finally(() => {
                  this.verificarAlertas()
                    .then(response => {
                      //console.log(response)
                    })
                    .catch(error => {
                      console.log(error);
                    })
                    .finally(() => {
                      this.masterLoad = false;
                    });
                });
            })
            .catch(error => {
              console.log(error);
              this.showError(403);
            })
            .finally(() => {});
        } else {
          this.preLogin(this.$route.params.id)
            .then(response => {
              if (!response.data.status) {
                this.showError(401);
                return;
              }

              this.obterAssinatura()
                .then(response => {
                  this.fetchListaEmpresas();
                  //console.log(response)
                })
                .catch(error => {
                  console.log(error);
                })
                .finally(() => {
                  this.verificarAlertas()
                    .then(response => {
                      //console.log(response)
                    })
                    .catch(error => {
                      console.log(error);
                    })
                    .finally(() => {
                      this.masterLoad = false;
                    });
                });
            })
            .catch(error => {
              console.log(error);

              if (error.response) {
                this.showError(error.response.status);
              } else {
                this.showError(403);
              }
            })
            .finally(() => {});
        }
      }
    },

    showError(error) {
      localStorage.clear();
      switch (error) {
        case 405:
          this.icon = "hand-paper";
          this.mensagem =
            "Acesso não autorizado! <br /> Identificado acessos simultâneos.<br /> Aguarde um instante e tente novamente!";
          break;
        case 404:
          this.icon = "exclamation-triangle";
          this.mensagem = "Caminho não encontrado! <br /> Por favor verifique a url.";
          break;
        case 403:
          this.icon = "hand-paper";
          this.mensagem =
            "Acesso não autorizado! <br /> Por favor logue pelo site <br /> <a href='http://www.econeteditora.com.br/'>Econet Editora Empresarial</a>.";
          break;
        case 401:
          this.icon = "heartbeat";
          this.mensagem = "Token Inválido! <br /> Por favor logue novamente no sistema.";
          break;
        default:
          this.icon = "key";
          this.mensagem = "Erro inesperado! <br /> Por favor tente novamente.";
          break;
      }
      this.error = true;
      this.masterLoad = false;
    }
  }
};
</script>
<style scoped lang="scss">
html {
  overflow: hidden !important;
  // background-color: var(--preto);
  // background-image: url("../../assets/images/agsquare.png");
}

.externa {
  position: relative;
  width: calc(100vw - 0px);
  height: calc(100vh - 0px);
}

.interna {
  left: 50%;
  top: 50%;
  margin-left: -100px;
  margin-top: -50px;
  position: absolute;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  vertical-align: middle;
  background-image: url("../../assets/images/loading_econet.gif");
}
</style>
